import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { DEFAULT_TIME } from "../../constants/input-entries-constants";
import getKhattabatStore from "../../stores/khattabat-stores";
import getKhattabatSharedMessagingStore from "../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import getKhattabat102MessagingStore from "../../stores/khattabat-stores/messaging-stores/102-messaging-store";
export const apiCallSendOneOTwoMessage = async ({
  oneOTwoConversationId
}: {
  oneOTwoConversationId: string;
}): Promise<{
  data: {
    currentTime: string;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { messageField } = getKhattabatSharedMessagingStore(
    oneOTwoConversationId
  );
  const {
    clientReceiverID,
    clientReceiverUUID,
    matchReceiverID,
    matchReceiverUUID
  } = getKhattabat102MessagingStore(oneOTwoConversationId);
  const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();

  const { status, data, et3Error } = await post<{
    currentTime: string;
  }>(`khattabat/sendOneOTwoMsg`, {
    alkhattabaUUID,
    clientUserID: clientReceiverID.get(),
    clientUUID: clientReceiverUUID.get(),
    matchID: matchReceiverID.get(),
    matchUUID: matchReceiverUUID.get(),
    alkhattabaText: messageField.get()
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        currentTime: DEFAULT_TIME
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        currentTime: DEFAULT_TIME
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
